
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { Coins } from "lucide-react";

interface CreditSwapFormProps {
  creditAmount: number;
  setCreditAmount: (value: number) => void;
}

const CreditSwapForm: React.FC<CreditSwapFormProps> = ({ creditAmount, setCreditAmount }) => {
  const handleSliderChange = (value: number[]) => {
    setCreditAmount(value[0]);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 10 && value <= 100) {
      setCreditAmount(value);
    }
  };

  return (
    <Card>
      <CardContent className="space-y-6 pt-6">
        <p className="text-sm text-muted-foreground mb-4">
          Offer credits for this reagent. The owner will receive these credits if they accept your request.
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Coins className="h-5 w-5 text-amber-500 mr-2" />
            <span className="font-medium">Credit Offer:</span>
          </div>
          <div className="w-20">
            <Input
              type="number"
              min={10}
              max={100}
              value={creditAmount}
              onChange={handleInputChange}
              className="text-center"
            />
          </div>
        </div>
        
        <Slider
          value={[creditAmount]}
          min={10}
          max={100}
          step={5}
          onValueChange={handleSliderChange}
          className="py-4"
        />
        
        <div className="flex justify-between text-sm text-muted-foreground">
          <span>10 credits</span>
          <span>100 credits</span>
        </div>
        
        <div className="bg-muted p-4 rounded-md mt-6">
          <h4 className="font-medium mb-2">About Credits</h4>
          <p className="text-sm text-muted-foreground">
            Credits are the virtual currency used in our reagent sharing platform. You can earn credits by sharing your own reagents and use them to request reagents from others.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditSwapForm;
